module.exports = __webpack_public_path__ + "media/stylesheets/images/lp/ltv/logo_footer-62f947ebf78603d28e312da74195cd01.svg";